(() => {
  const initDeliveryPage = (root) => {
    if (!root || root.dataset.deliveryInitialized === 'true') return;

    const chatButton = root.querySelector('[data-delivery-chat]');
    const triggerId = root.dataset.chatTriggerId || 'Avada-FAQ_WidgetTrigger';

    if (chatButton) {
      chatButton.addEventListener('click', () => {
        const openChat = () => {
          const trigger = document.getElementById(triggerId);
          if (!trigger) return false;
          trigger.click();
          return true;
        };

        if (openChat()) return;

        let attempts = 0;
        const retry = window.setInterval(() => {
          attempts += 1;
          if (openChat() || attempts >= 6) {
            window.clearInterval(retry);
          }
        }, 350);
      });
    }

    root.dataset.deliveryInitialized = 'true';
  };

  const initAll = () => {
    document.querySelectorAll('[data-delivery-root]').forEach(initDeliveryPage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-delivery-root]');
    initDeliveryPage(root);
  });
})();
